import { http } from "@/utils/http";
import {
  EmployeeItem,
  RefreshTokenResult,
  UserListData,
  UserResult
} from "./user.d";
import { ListSearchParam, ListSearchResult, ResponseResult } from "./common";

/** 获取部门用户列表 */
export const fetchDeptUsers = () => {
  return http.request<ResponseResult<UserListData[]>>("get", "/user/deptUsers");
}

export const fetchGenUserToken = (id?: number) => {
  return http.request<ResponseResult<UserListData>>("post", "/user/genKey", {
    data: { id }
  });
};
/** 生成用户key */
export const fetchGenUserKey = (id?: number) => {
  return http.request<ResponseResult<UserListData>>("post", "/busapi/genUserKeyPair", {
    data: { id }
  });
};
/** 新增用户 */
export const fetchAddUser = (data?: UserListData) => {
  return http.request<ResponseResult<UserListData>>("post", "/user/add", {
    data
  });
};
/** 用户信息 */
export const fetchUserInfo = (data?: UserListData) => {
  return http.request<ResponseResult<UserListData>>("get", "/user/info", {
    data
  });
};
/** 修改用户 */
export const fetchUpdateUser = (data?: Partial<UserListData>) => {
  return http.request<ResponseResult<UserListData>>("post", "/user/update", {
    data
  });
};

/** 获取用户列表 */
export const fetchUserSearch = (data?: ListSearchParam) => {
  return http.request<ResponseResult<UserListData[]>>("post", "/user/search", {
    data
  });
};

/** 获取全部用户 */
export const fetchUserList = (data?: ListSearchParam) => {
  return http.request<ResponseResult<EmployeeItem[]>>(
    "post",
    "/user/allUsers",
    {
      data
    }
  );
};
/** 获取用户列表 */
export const fetchUserPageList = (data?: ListSearchParam) => {
  return http.request<ResponseResult<ListSearchResult<EmployeeItem>>>(
    "post",
    "/user/list",
    {
      data
    }
  );
};
/**
 * 获取公证员
 */
export const fetchNotaryEmployeeList = () => {
  const data = {
    condition: {
      "roles.name": "普通公证员"
    }
  };
  return http.request<ResponseResult<EmployeeItem[]>>(
    "post",
    "/user/notaryList",
    {
      data
    }
  );
};

/** 登录 */
export const fetchLogin = (data?: object) => {
  return http.request<ResponseResult<UserResult>>("post", "/user/login", {
    data
  });
};

/** 自动登录 */
export const fetchAutoLogin = (tk: string) => {
  return http.request<ResponseResult<UserResult>>("post", "/user/autologin", {
    data: { tk }
  });
};

/** 刷新token */
export const fetchRefreshToken = (data?: object) => {
  return http.request<ResponseResult<RefreshTokenResult>>(
    "post",
    "/user/refreshToken",
    {
      data
    }
  );
};
/** 修改密码 */
export const userNewPass = (data?: object) => {
  return http.request<ResponseResult<RefreshTokenResult>>(
    "post",
    "/user/newPass",
    {
      data
    }
  );
}
